<!--控制台首页-->
<template>
  <div class="consoleIndex-wrap">
    <img class="tbg" src="/images/console/tbg.png" style="margin-top: -60px" />

    <div class="main-box">
      <div class="left-box">
        <div class="box b1">
          <div class="top">
            <img src="/images/console/start-i.png" />
            <span class="title"> 简单 3 步，快速开启企业电子签署之旅 ~ </span>
            <span class="todo can_use" @click="turnToJC">查看教程 >></span>
          </div>
          <div class="img_content">
            <img
              class="can_use tp"
              src="/images/console/mem-a.png"
              @click="turnToZZ"
            />
            <img class="po1" src="/images/console/arr-r-a.png" />
            <img
              class="can_use tp"
              src="/images/console/sp-a.png"
              @click="turnToSP"
            />
            <img class="po2" src="/images/console/arr-r-a.png" />
            <img
              class="can_use tp"
              src="/images/console/yz-a.png"
              @click="turnToYZ"
            />
          </div>
        </div>
        <div class="box b2">
          <div class="top">
            <img src="/images/console/zz-i.png" />
            <span class="title"> 企业组织管理</span>
            <span class="can_use todo" @click="turnToZZ">立刻进入>></span>
          </div>
          <div class="content">
            <img src="/images/console/zz_l.png" />
            <div class="i-tips-msk">
              <p class="i-tips">
                企业组织管理包括成员管理、权限管理、组织管理。您可调整架构、邀请成员、分配权限。
              </p>
            </div>

            <div class="des">
              <p class="title">成员管理</p>
              <p class="tips">
                邀请成员加入，调整成员部门、分配成员权限、移出组织架构，数据转移继承
              </p>
              <p class="title">权限管理</p>
              <p class="tips">
                设置角色权限按需授权，获得权限的成员则可以使用系统相应的功能
              </p>
              <p class="title">组织管理</p>
              <p class="tips">
                树形结构管理体系，企业成员灵活管理，可与审批流程关联实现层级审批
              </p>
            </div>
          </div>
        </div>
        <div class="box b3">
          <div class="top">
            <img src="/images/console/sp-i.png" />
            <span class="title"> 成员合同审批</span>
            <span class="can_use todo" @click="turnToSP">立刻进入>></span>
          </div>
          <div class="content">
            <img src="/images/console/sp_l.png" />
            <div class="i-tips-msk">
              <p>
                合同审批流程包括文件审批、用印审批和流程审批。您可对文件审批、用印审批、流程审批进行设置。
              </p>
            </div>
            <div class="des">
              <p class="title">文件审批</p>
              <p class="tips">
                若发出签署文件前需要先审阅文件的内容，则可以设置对应的“文件审批流程”，在发出签署文件时关联对应的“文件审批流程”，审批通过签署方才会收到对应的签署文件
              </p>
              <p class="title">用印审批</p>
              <p class="tips">
                若签署文件时需要先审阅文件的内容，则需设置“用印审批流程”后与对应的印章做关联绑定，签署文件时审批通过，印章才会落到签署文件上
              </p>
            </div>
          </div>
        </div>
        <div class="box b2">
          <div class="top">
            <img src="/images/console/yz-i.png" />
            <span class="title"> 印章授权</span>
            <span class="can_use todo" @click="turnToYZ">立刻进入>></span>
          </div>
          <div class="content">
            <img src="/images/console/yz_l.png" />
            <div class="i-tips-msk">
              <p>
                企业印章管理包括印章创建、印章授权和审批关联。您可进行添加印章、授权印章、关联印章和流程等操作。
              </p>
            </div>

            <div class="des">
              <p class="title">印章创建</p>
              <p class="tips">
                把签署各种文件时需要用到的“印章”，以“透明印模图片”的形式上传到系统中集中管理
              </p>
              <p class="title">印章授权</p>
              <p class="tips">
                按需把不同用途的印章，分别授权给相应的企业成员在签署不同文件时使用
              </p>
              <p class="title">审批关联</p>
              <p class="tips">
                使用印章签署文件时若需要先审阅文件内容，则需要将印章与对应的“用印审批流程”进行关联，审批通过印章才会落到需签署文件上
              </p>
            </div>
          </div>
        </div>
        <div class="box b2">
          <div class="top">
            <img src="/images/console/mb-i.png" />
            <span class="title"> 模板授权</span>
            <span class="can_use todo" @click="turnToMB">立刻进入>></span>
          </div>
          <div class="content">
            <img src="/images/console/mb_l.png" />
            <div class="i-tips-msk">
              <p>
                企业模板管理包括模板维护、模板授权和批量发起。您可进行维护模板、新建模板、授权模板和批量发起模板等操作。
              </p>
            </div>

            <div class="des">
              <p class="title">模板维护</p>
              <p class="tips">
                把各类业务签署时需要使用到的文档，创建为模板统一管理维护，避免文档模板使用中逐渐碎片化
              </p>
              <p class="title">模板授权</p>
              <p class="tips">
                按需把不同类型的模板授权给相应的成员使用，防止成员私自使用不规范文档模板签署，避免不必要的司法纠纷
              </p>
              <p class="title">批量发起</p>
              <p class="tips">
                使用时，支持通过Excel按不同的签署方分别录入不同的内容到模板中，并批量发出多份签署文件
              </p>
            </div>
          </div>
        </div>
        <div class="box b6">
          <div class="top">
            <img src="/images/console/sjtj-i.png" />
            <span class="title"> 数据统计</span>
          </div>
          <div class="chartBox">
            <div>
              <console-pie id="chart1" :chartData="chartSign" />
            </div>
            <div>
              <console-pie id="chart2" :chartData="chartApproval" />
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="box-1">
          <div class="top">
            <span><i></i>企业成员</span>
          </div>
          <div class="content">
            <div class="box-con">
              <h1 class="title">{{ userCount.successCount }}</h1>
              <p><span class="in-icon ic1"></span>已加入</p>
            </div>
            <div class="box-con">
              <h1 class="title">{{ userCount.inviteCount }}</h1>
              <p><span class="in-icon ic2"></span>待接受</p>
            </div>
            <div class="box-con">
              <h1 class="title">{{ userCount.removeCount }}</h1>
              <p><span class="in-icon ic3"></span>已移除</p>
            </div>
          </div>
          <div class="foot" @click="showAddMem">
            <img src="/images/console/add.png" />添加成员
          </div>
        </div>
        <div class="box-2">
          <div class="top">
            <span><i></i>快捷入口</span>
          </div>
          <div class="content">
            <div class="can_use mod" @click="turnToZZ">
              <i class="in-icon ic1"></i>
              <p>企业组织管理</p>
            </div>
            <div class="can_use mod" @click="turnToSP">
              <i class="in-icon ic2"></i>
              <p>成员合同审批</p>
            </div>
            <div class="can_use mod" @click="turnToYZ">
              <i class="in-icon ic3"></i>
              <p>印章授权</p>
            </div>
            <div class="can_use mod" @click="turnToMB">
              <i class="in-icon ic4"></i>
              <p>模板授权</p>
            </div>
          </div>
          <div class="foot can_use" @click="turnToJC">查看教程 >></div>
        </div>
      </div>
    </div>
    <!-- 添加成员 Dialog -->
    <add-member :show.sync="visibleAddMember" :callback="addMemberSus" />
  </div>
</template>

<script>
import consolePie from "@/components/charts/console-pie.vue";
import addMember from "@/components/console/addMember";
import {
  findUserCount,
  findSignStatusCount
} from "../../assets/js/http-serve/corp/http-methods";
import { isInDingTalk } from '@/assets/js/utils/ding-env'

export default {
  name: "consoleIndex",
  components: {
    consolePie,
    addMember
  },
  props: {},
  data () {
    return {
      hasSeal: false, //是否有印章权限
      hasMem: false, //是否有成员权限
      hasFlow: false, //是否有审批权限
      hasTemp: false, //是否有模板权限
      visibleAddMember: false,
      userCount: {
        inviteCount: "--",
        removeCount: "--",
        successCount: "--"
      },
      chartSign: {
        title: "文件签署",
        data: [
          {
            value: 0,
            name: "待签署",
            itemStyle: {
              color: "#FF8478"
            }
          },
          {
            value: 0,
            name: "已拒签",
            itemStyle: {
              color: "#FCB270"
            }
          },
          {
            value: 0,
            name: "已完成",
            itemStyle: {
              color: "#76DEFD"
            }
          },
          {
            value: 0,
            name: "已过期",
            itemStyle: {
              color: "#AD95FC"
            }
          }
        ]
      },
      chartApproval: {
        title: "文件审批",
        data: [
          {
            value: 0,
            name: "待审批",
            itemStyle: {
              color: "#FF8478"
            }
          },
          {
            value: 0,
            name: "审批驳回",
            itemStyle: {
              color: "#76DEFD"
            }
          }
        ]
      }
    };
  },

  created () {
    this.searchUserCount();
    this.finChartData();
    this.getperms(this.$store.getters.consoleToken);
  },

  watch: {
    "$store.getters.consoleToken": {
      handler (newVal) {
        this.getperms(newVal);
      },
      deep: true
    },
    "$store.getters.currentAuthUser": {
      handler (newVal) {
        this.getperms(newVal);
        this.searchUserCount();
        this.finChartData();
      },
      deep: true
    }
  },

  methods: {
    addMemberSus () {
      this.$message.success("已邀请");
      this.searchUserCount();
    },
    // 企业用户登录高级版首页查询用户统计量
    searchUserCount () {
      findUserCount().then(result => {
        if (result && result.data) {
          this.userCount = result.data;
        } else {
          this.$message.error(result.description || this.$tip);
        }
      });
    },

    finChartData () {
      findSignStatusCount().then(result => {
        if (result && result.data) {
          // this.userCount = result.data
          let data = result.data;
          this.chartSign.data = [
            {
              value: data.inprogressCount,
              name: "待签署",
              itemStyle: {
                color: "#FF8478"
              }
            },
            {
              value: data.refuseCount,
              name: "已拒签",
              itemStyle: {
                color: "#FCB270"
              }
            },
            {
              value: data.completedCount,
              name: "已完成",
              itemStyle: {
                color: "#76DEFD"
              }
            },
            {
              value: data.exipreCount,
              name: "已过期",
              itemStyle: {
                color: "#AD95FC"
              }
            }
          ];
          this.chartApproval.data = [
            {
              value: data.waitApprovaCount,
              name: "待审批",
              itemStyle: {
                color: "#FF8478"
              }
            },
            {
              value: data.refaultApprovaCount,
              name: "审批驳回",
              itemStyle: {
                color: "#76DEFD"
              }
            }
          ];
        } else {
          this.$message.error(result.description || this.$tip);
        }
      });
    },

    //新增根据权限可点击跳转等操作按钮
    getperms (consoleToken = this.$store.getters.consoleToken) {
      this.$nextTick(() => {
        this.hasMem = consoleToken.perms.some(i => +i == 3);
        this.hasSeal = consoleToken.perms.some(i => +i == 4);
        this.hasFlow = consoleToken.perms.some(i => +i == 12);
        this.hasTemp = consoleToken.perms.some(i => +i == 6);
      });
    },

    turnToMB () {
      //跳转企业模板页
      // this.hasTemp &&
      //   this.$router.push({
      //     path: "/console/setting",
      //     query: {
      //       activeName: "tab-template"
      //     }
      //   });
      this.hasMem &&
        this.$router.push({
          path: "/console/template"
        });
      !this.hasTemp && this.$message.info("您还没有此权限，请开通后重试");
    },

    turnToZZ () {
      //跳转企业成员页
      // this.hasMem &&
      //   this.$router.push({
      //     path: "/console/setting",
      //     query: {
      //       activeName: "tab-member"
      //     }
      //   });
      this.hasMem &&
        this.$router.push({
          path: "/console/member"
        });
      !this.hasMem && this.$message.info("您还没有此权限，请开通后重试");
    },
    turnToSP () {
      //跳转审批流程
      // this.hasFlow &&
      //   this.$router.push({
      //     path: "/console/setting",
      //     query: {
      //       activeName: "tab-approval"
      //     }
      //   });
      this.hasFlow &&
        this.$router.push({
          path: "/console/flow"
        });
      !this.hasFlow && this.$message.info("您还没有此权限，请开通后重试");
    },

    turnToYZ () {
      //跳转印章管理
      // this.hasSeal &&
      //   this.$router.push({
      //     path: "/console/setting",
      //     query: {
      //       activeName: "tab-seal"
      //     }
      //   });
      this.hasSeal &&
        this.$router.push({
          path: "/console/seal"
        });
      !this.hasSeal && this.$message.info("您还没有此权限，请开通后重试");
    },

    showAddMem () {
      //展示添加成员的弹窗
      this.hasMem && (this.visibleAddMember = true);
      !this.hasMem && this.$message.info("您还没有此权限，请开通后重试");
    },

    turnToJC () {
      //跳转教程页
      let new_window;
      if (!isInDingTalk) new_window = window.open("", "_blank");
      const path = "/" + encodeURIComponent("君子签SASS高级版操作手册") + ".pdf"
      isInDingTalk ? location.href = path : new_window.location.href =
        path;
      // new_window.close();
    }
  }
};
</script>

<style lang="less" scoped>
.tbg {
  width: 100%;
  min-height: 100px;
}

.main-box {
  width: 1200px;
  margin: 30px auto 40px auto;
  display: flex;

  .left-box {
    width: 930px;
    margin-right: 20px;

    .box {
      width: inherit;
      height: 311px;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 10px;

      &:first-child {
        height: 216px;
      }

      &:last-child {
        height: 329px;
      }

      .top {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #eeeeee;
        position: relative;

        img {
          margin-left: 10px;
          margin-right: 5px;
          vertical-align: sub;
        }

        .title {
          font-size: 16px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #290202;
        }

        .todo {
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: rgba(41, 2, 2, 0.45);
          margin-right: 15px;
          right: 0;
          position: absolute;
          &:hover {
            color: #ec1c1c;
          }
        }
      }

      .content {
        display: flex;
        position: relative;

        img {
          margin: 20px 50px 20px 15px;
        }

        .i-tips-msk {
          height: 60px;
          position: absolute;
          width: 396px;
          bottom: 21px;
          left: 15px;
          color: #ffffff;
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          padding: 16px 7px 8px 8px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.67) 100%
          );
          opacity: 1;
          border-radius: 0px 0px 10px 10px;
        }

        .des {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-right: 50px;
          width: 470px;

          p {
            word-wrap: break-word;
          }

          .title {
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #290202;
            line-height: 20px;
            margin-bottom: 5px;
          }

          .tips {
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: rgba(41, 2, 2, 0.45);
            line-height: 14px;
          }
        }
      }
    }

    .b1 {
      .img_content {
        position: relative;
        padding: 20px 0 20px 15px;

        .tp {
          margin-right: 10px;
          &:hover {
            transform: translateY(-5px);
          }
        }

        .po1 {
          position: absolute;
          bottom: 19px;
          left: 287px;
          z-index: 1;
        }

        .po2 {
          position: absolute;
          bottom: 19px;
          right: 276px;
          z-index: 1;
        }
      }
    }

    .b2 {
      .content {
        .des {
          .tips {
            margin-bottom: 14px;
          }
        }
      }
    }

    .b3 {
      .content {
        .des {
          .tips {
            margin-bottom: 30px;
          }
        }
      }
    }

    .b6 {
      .chartBox {
        padding: 0;

        > div {
          width: 50%;
          height: 270px;
          box-sizing: border-box;
          float: left;
        }
      }
    }
  }

  .right-box {
    width: 250px;

    .top {
      padding: 12px 0;
      height: 44px;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      line-height: 20px;
      color: #290202;
      border-bottom: solid 1px #eeeeee;

      span {
        display: flex;
        align-items: center;
      }

      i {
        width: 4px;
        height: 14px;
        display: inline-block;
        margin-right: 6px;
        background: #290202;
      }
    }

    .box-1 {
      height: 197px;
      background: #ffffff;
      border-radius: 10px;

      .content {
        height: 119px;
        display: flex;
        align-items: center;

        .box-con {
          flex: 1;
          text-align: center;
          height: 55px;

          &:hover {
            /* .title,
              p {
                color: #EC1C1C;
              }

              .ic1 {
                background: url("/images/console/joined-on.png") no-repeat;
                background-size: 100% 100%;
              }

              .ic2 {
                background: url("/images/console/waited-on.png") no-repeat;
                background-size: 100% 100%;
              }

              .ic3 {
                background: url("/images/console/outed-on.png") no-repeat;
                background-size: 100% 100%;
              } */
          }

          .title {
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: 800;
            color: #290202;
          }

          p {
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: rgba(41, 2, 2, 0.45);
          }

          .in-icon {
            vertical-align: middle;
            width: 14px;
            height: 14px;
            margin-right: 2px;
            display: inline-block;
            vertical-align: sub;
          }

          .ic1 {
            background: url(/images/console/joined.png) no-repeat;
            background-size: 100% 100%;
          }

          .ic2 {
            background: url(/images/console/waited.png) no-repeat;
            background-size: 100% 100%;
          }

          .ic3 {
            background: url(/images/console/outed.png) no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .foot {
        cursor: pointer;
        background: #ec1c1c;
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;

        &:hover {
          opacity: 0.7;
        }
      }

      .foot img {
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
    }

    .box-2 {
      height: 282px;
      background: #ffffff;
      margin-top: 20px;
      border-radius: 10px;

      .content {
        height: 206px;
        clear: both;
        border-bottom: 1px solid #eeeeee;

        .mod {
          height: 65px;
          width: 85px;
          text-align: center;
          float: left;
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: rgba(41, 2, 2, 0.45);
          margin: 24px 20px 0;

          &:hover {
            color: #ec1c1c;
            .ic1 {
              background: url("/images/console/zz-on.png") no-repeat;
              background-size: 100% 100%;
            }

            .ic2 {
              background: url("/images/console/sp-on.png") no-repeat;
              background-size: 100% 100%;
            }

            .ic3 {
              background: url("/images/console/yz-on.png") no-repeat;
              background-size: 100% 100%;
            }

            .ic4 {
              background: url("/images/console/mb-on.png") no-repeat;
              background-size: 100% 100%;
            }
          }

          .in-icon {
            width: 32px;
            height: 32px;
            margin-bottom: 2px;
            display: inline-block;
          }

          .ic1 {
            background: url("/images/console/zz_r.png") no-repeat;
            background-size: 100% 100%;
          }

          .ic2 {
            background: url("/images/console/sp_r.png") no-repeat;
            background-size: 100% 100%;
          }

          .ic3 {
            background: url("/images/console/yz_r.png") no-repeat;
            background-size: 100% 100%;
          }

          .ic4 {
            background: url("/images/console/mb_r.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .foot {
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: rgba(41, 2, 2, 0.45);

        &:hover {
          color: #ec1c1c;
        }
      }
    }
  }
}

.can_use {
  cursor: pointer;
}

.no_use {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// pages/console/consoleIndex.vue